module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('accordion-item', {
    attrs: {
      "keep-closed": true,
      "content-pull": true
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n            General Damages\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "m-div-table__holder"
  }, [_c('benefit', {
    attrs: {
      "store-key": "gdPneumoconiosis",
      "title": "General Damages",
      "subtitle": "Pneumoconiosis etc, (Workers Compensation) Act 1979 including any extra statutory payments made following the rejection of a claim under the 1979 Act",
      "show-header": ""
    }
  }), _vm._v(" "), _c('benefit', {
    attrs: {
      "title": "General Damages",
      "store-key": "gdMesothelioma",
      "subtitle": "2008 Diffuse Mesothelioma Scheme",
      "is-last": "",
      "show-header": ""
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51d66f43!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/cru-benefits/GeneralDamages.vue
// module id = 1688
// module chunks = 0